import { Component, ElementRef, OnInit, AfterViewInit, AfterViewChecked, OnDestroy } from '@angular/core';
import { from } from 'rxjs';

import { AnalyticsService } from 'src/app/shared/services/fb-analytics.service';
import { GeneralService } from '@src/app/shared/services/general.service';
import { HtmlElementService } from '@src/app/shared/services/html-element.service';
import { ContentService } from '@src/app/shared/services/content.service';
import { deferState } from '@src/app/shared/animations/animations';


@Component({
  selector: 'nh-home-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
  animations: [
    deferState
  ]
})

export class ContactComponent implements OnInit, AfterViewInit, AfterViewChecked, OnDestroy {
  forceLoad: boolean;
  topPos: number;

  resumeURL: string;

  constructor(
    protected analyticsService: AnalyticsService,
    protected generalService: GeneralService,
    private HtmlElementService: HtmlElementService,
    private contentService: ContentService,
    private contactHTML: ElementRef
  ) { }

  // Lifecycle Hooks

  ngOnInit(): void {
    from(this.contentService.getAssetURL('55VKR61YMr6sfC5HlvLXJW')).subscribe((res) => {
      return this.resumeURL = res;
    })
  }

  ngAfterViewInit(): void {
    this.topPos = this.contactHTML.nativeElement.offsetTop;

    this.HtmlElementService.setElement(
      'contact',
      this.contactHTML.nativeElement
    )
  }

  ngAfterViewChecked(): void {
    if (!this.forceLoad) {
      this.topPos = this.contactHTML.nativeElement.offsetTop;

      if (this.topPos <= this.generalService.scrollElTopPos) {
        this.forceLoad = this.generalService.forceLoad;
      }
    }
  }

  ngOnDestroy(): void {
  }
}
